@if (details.length > 0) {
  <main class="details-container">
    <section>
      <section class="table-container">
        @if (allTab() && applicationsRoute) {
          <p class="description">The following applications are in progress.</p>
        }
        <table class="custom-table">
          <thead>
            @if (consolidatedView) {
              <tr>
                <th>Bursar Full Name</th>
                @if (!applicationsRoute) {
                  <th>University</th>
                }
                <th>Bursary Amount</th>
                @if (allTab() && applicationsRoute) {
                  <th>Bursary Fund</th>
                }
                @if (allTab() && applicationsRoute) {
                  <th>Status</th>
                }
                @if (!allTab()) {
                  <th></th>
                }
              </tr>
            }
            @if (!consolidatedView) {
              <tr>
                <th class="bottom-align">Bursar Full Name</th>
                @if (!applicationsRoute) {
                  <th class="bottom-align">University</th>
                }
                @if (eventsRoute) {
                  <th class="bottom-align">RSVP</th>
                }
                @if (eventsRoute) {
                  <th class="bottom-align">Location</th>
                }
                @if (eventsRoute) {
                  <th class="bottom-align">Dietary Requirements</th>
                }
                @if (eventsRoute) {
                  <th class="bottom-align">Notes</th>
                }
              </tr>
            }
          </thead>
          <tbody>
            @if (consolidatedView) {
              @for (
                detail of detailsAsDetails;
                track detail;
                let index = $index
              ) {
                <tr
                  [ngStyle]="{
                    'border-bottom':
                      applicationArrayLength &&
                      applicationArrayLength - 1 === index
                        ? 'none'
                        : '1px solid primary'
                  }"
                  [ngClass]="{ 'no-button-table': allTab() }"
                >
                  <td data-label="Bursar Full Name">
                    <p class="center-text">{{ detail.fullName }}</p>
                  </td>
                  @if (!applicationsRoute) {
                    <td data-label="University">{{ detail.universityName }}</td>
                  }
                  @if (!eventsRoute) {
                    <td data-label="Bursary Amount">
                      {{ detail.amount | customCurrency }}
                    </td>
                  }
                  @if (allTab() && applicationsRoute) {
                    <td data-label="Bursary Fund">{{ detail.bursaryType }}</td>
                  }
                  @if (allTab() && applicationsRoute) {
                    <td data-label="Status">
                      {{ getCurrentStatus(detail.status) }}
                    </td>
                  }
                  @if (!allTab()) {
                    <td>
                      <section class="button-container">
                        @if (currentTab !== "Email Failed") {
                          <button
                            mat-flat-button
                            color="primary"
                            (click)="
                              navigateToDetailsPage(detail.applicationGuid)
                            "
                          >
                            {{ buttonAction.VIEW }}
                          </button>
                        }
                        @if (currentTab === "Email Failed") {
                          <button
                            mat-flat-button
                            color="primary"
                            (click)="
                              navigateToEmailFailed(detail.applicationGuid)
                            "
                          >
                            {{ buttonAction.VIEW }}
                          </button>
                        }
                      </section>
                    </td>
                  }
                </tr>
              }
            }
            @if (!consolidatedView) {
              @for (
                detail of detailsAsInvitees;
                track detail;
                let index = $index
              ) {
                <tr
                  [ngStyle]="{
                    'border-bottom':
                      applicationArrayLength &&
                      applicationArrayLength - 1 === index
                        ? 'none'
                        : '1px solid primary'
                  }"
                >
                  <td data-label="Bursar Full Name">
                    {{ detail.firstName }} {{ detail.surname }}
                  </td>
                  <td data-label="University">{{ detail.universityName }}</td>
                  @if (eventsRoute) {
                    <td data-label="RSVP">{{ detail.rsvp }}</td>
                  }
                  @if (eventsRoute) {
                    <td data-label="Location">{{ detail.location }}</td>
                  }
                  @if (eventsRoute) {
                    <td data-label="Dietary Requirements">
                      {{ detail.dietaryRequirements }}<br />{{
                        getAllergies(detail)
                      }}
                    </td>
                  }
                  @if (eventsRoute) {
                    <td data-label="Notes">{{ getNotes(detail) }}</td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </section>
    </section>
  </main>
} @else {
  <p class="error-text">{{ noDetailsMessage }}</p>
}
<section class="error-text-container"></section>
